import reQrcode from './index.vue'
import { withInstall } from '@pureadmin/utils'

// /** 二维码组件 */
export const ReQrcode = withInstall(reQrcode)

export default ReQrcode
